import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/products',
    name: 'produtos',
    component: () => import ('../views/ProdutosView.vue')
  },
  {
    path: '/questions',
    name: 'duvidas',
    component: () => import ('../views/DuvidasView.vue')
  },
  {
    path: '/peliculas-profissionais',
    name: 'peliculas profissionais',
    component: () => import ('../views/produtos/categorias/ProfissionalView.vue')
  },
  {
    path: '/peliculas-nanoceramica',
    name: 'peliculas nanoceramica',
    component: () => import ('../views/produtos/categorias/NanoceramicaView.vue')
  },
  {
    path: '/peliculas-de-seguranca',
    name: 'peliculas de seguranca',
    component: () => import ('../views/produtos/categorias/SegurancaView.vue')
  },
  {
    path: '/peliculas-arquitetura-e-decorativa',
    name: 'peliculas arquitetura e decorativa',
    component: () => import ('../views/produtos/categorias/ArquiteturaView.vue')
  },
  {
    path: '/contato-sao-luis-ma',
    name: 'Contato São Luís',
    component: () => import ('../views/ContatoSaoLuis.vue')
  },

  // ROTAS PÁGINAS PELÍCULAS AUTOMOTIVAS

  {
    path: '/carbon-20',
    name: 'Carbon 20',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CarbonVinte.vue')
  },
  {
    path: '/carbon-35',
    name: 'Carbon 35',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CarbonTrintacinco.vue')
  },
  {
    path: '/carbon-5',
    name: 'Carbon 5',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CarbonCinco.vue')
  },
  {
    path: '/cobalto-20',
    name: 'Cobalto 20',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CobaltoVinte.vue')
  },
  {
    path: '/cobalto-35',
    name: 'Cobalto 35',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CobaltoTrintacinco.vue')
  },
  {
    path: '/cobalto-5',
    name: 'Cobalto 5',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/CobaltoCinco.vue')
  },
  {
    path: '/tgn-ir-rayban-20',
    name: 'TGN IR Rayban 20',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/TgnVinte.vue')
  },
  {
    path: '/tgn-ir-rayban-35',
    name: 'TGN IR Rayban 35',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/TgnTrintacinco.vue')
  },
  {
    path: '/tgn-ir-rayban-5',
    name: 'TGN IR Rayban 5',
    component: () => import ('../views/produtos/paginas/peliculasAutomotivas/TgnCinco.vue')
  }

  // ROTAS PÁGINAS PELÍCULAS NANO CERÂMICA

  ,
  {
    path: '/sublime-blue-70',
    name: 'Sublime Blue 70',
    component: () => import ('../views/produtos/paginas/peliculasNanoceramica/SublimeBlue70.vue')
  },
  {
    path: '/sublime-green-70',
    name: 'Sublime Green 70',
    component: () => import ('../views/produtos/paginas/peliculasNanoceramica/SublimeGreen70.vue')
  },
  {
    path: '/sublime-5',
    name: 'Sublime Advance 5',
    component: () => import ('../views/produtos/paginas/peliculasNanoceramica/SublimeAdvance5.vue')
  },
  {
    path: '/sublime-20',
    name: 'Sublime Advance 20',
    component: () => import ('../views/produtos/paginas/peliculasNanoceramica/SublimeAdvance20.vue')
  },
  {
    path: '/sublime-35',
    name: 'Sublime Advance 35',
    component: () => import ('../views/produtos/paginas/peliculasNanoceramica/SublimeAdvance35.vue')
  },
  
  // ROTAS PÁGINAS PELÍCULAS DECORATIVAS

  {
    path: '/mini-blind',
    name: 'Mini Blind',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/MiniBlind.vue')
  },
  {
    path: '/venetian-blind',
    name: 'Venetian Blind',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/VenetianBlind.vue')
  },
  {
    path: '/quadriculado',
    name: 'Película Quadriculado',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/PeliculaQuadriculado.vue')
  },
  {
    path: '/jateado-branco',
    name: 'Jateado Branco',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/JateadaBranca.vue')
  },
  {
    path: '/blackout',
    name: 'Película Blackout',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/PeliculaBlackout.vue')
  },
  {
    path: '/azul-natural-50',
    name: 'Azul Natural 50%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/AzulNatural50.vue')
  },
  {
    path: '/verde-natural-50',
    name: 'Verde Natural 50%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/VerdeNatural50.vue')
  },
  {
    path: '/verde-natural-35',
    name: 'Verde Natural 35%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/VerdeNatural35.vue')
  },

  // ROTAS PÁGINAS PELÍCULAS ARQUITETÔNICAS

  {
    path: '/prata-gray-5',
    name: 'Prata / Gray 5%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/PrataGray5.vue')
  },
  {
    path: '/prata-5',
    name: 'Prata 5%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/PrataCinco.vue')
  },
  {
    path: '/azul-prata-10',
    name: 'Azul / Prata 10%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/AzulPrata10.vue')
  },
  {
    path: '/verde-prata-10',
    name: 'Verde / Prata 10%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/VerdePrata10.vue')
  },
  {
    path: '/bronze-prata-10',
    name: 'Bronze / Prata 10%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/BronzePrata10.vue')
  },
  {
    path: '/ouro-prata-10',
    name: 'Ouro / Prata 10%',
    component: () => import ('../views/produtos/paginas/peliculaArquiDecor/OuroPrata10.vue')
  },

  // ROTAS PÁGINAS PELÍCULAS DE SEGURANÇA

  {
    path: '/sublime-security-5',
    name: 'Sublime Security PS4 BK 5%',
    component: () => import ('../views/produtos/paginas/peliculasSeguranca/SecutiryBk5.vue')
  },
  {
    path: '/sublime-security-20',
    name: 'Sublime Security PS4 BK 20%',
    component: () => import ('../views/produtos/paginas/peliculasSeguranca/SecutiryBk20.vue')
  },
  {
    path: '/sublime-security-35',
    name: 'Sublime Security PS4 BK 35%',
    component: () => import ('../views/produtos/paginas/peliculasSeguranca/SecutiryBk35.vue')
  },
  {
    path: '/sublime-security-clear',
    name: 'Sublime Security PS4 BK CLEAR',
    component: () => import ('../views/produtos/paginas/peliculasSeguranca/SecutiryClear.vue')
  },

  // ROTAS CONTATOS LOJAS

  {
    path: '/contato-lojas',
    name: 'Contato Lojas',
    component: () => import ('../views/contatos/PaginaContatoLojas.vue')
  },
  {
    path: '/contato-direto-fortaleza',
    name: 'Contato Direto Fortaleza',
    component: () => import ('../views/contatos/ContatosLojas.vue')
  },
  {
    path: '/contato-direto-sao-luis',
    name: 'Contato Direto Sao Luis',
    component: () => import ('../views/contatos/ContatosLojas.vue')
  },
  {
    path: '/contato-direto-imperatriz',
    name: 'Contato Direto imperatriz',
    component: () => import ('../views/contatos/ContatosLojas.vue')
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(_to, _from, _savedPosition) {
    return { top: 0 }
  }
})

export default router
